<div class="app-wrapper" *ngIf="access; else noFormsAccess">
    <nav class="tab_navigation">
        &nbsp;
    </nav>
    <section class="main-content settings-section forms-section">
        <div class="app-main">
            <header>
                <div class="data-header">
                  <core-title-section
                    [title]="'Forms'"
                    [description]="'This is where you have your system forms.'"
                    [breadcrumbs]="breadcrumbs"
                  ></core-title-section>
                  <div class="button-settings-add">
                    <core-helpers-navigation-three-dots-menu
                      [menu]="menu"
                      (action)="onMenuClick($event)"
                    ></core-helpers-navigation-three-dots-menu>
                  </div>
                </div>
            </header>
            <div class="box_default box_white forms-list">
                <div *ngIf="status == STATUS_DONE">
                    <h3><span>ALL FORMS</span></h3>
                    <ng-container *ngIf="forms?.length  > 0; else noFormsAvailable">
                        <ul class="forms-ul">
                            <core-helpers-lists-one-action-list-item
                                *ngFor="let form of forms | sortBy: 'name' : 'asc' | sortByActive "
                                [title]="form.name"
                                (titleClick)="onSelect(form)"
                                [actionText]="form.active? 'Deactivate' : 'Activate'"
                                (actionClick)="form.active? deactivate(form) : activate(form)"
                                [type]="form.active ? '': 'inactive disabled'"
                            ></core-helpers-lists-one-action-list-item>
                        </ul>
                    </ng-container>
                    <ng-template #noFormsAvailable>
                        <div class="empty-settings">
                            <core-helpers-box-alert-message-icon
                              [text]="'There are no forms available.'"
                              [icon]="'warning'"
                            ></core-helpers-box-alert-message-icon>
                          </div>
                    </ng-template>
                    
                   
                </div>
                <div class="loader">
                    <div class="dimmed" [hidden]="status == STATUS_DONE">
                        <div class="dimmed_title"></div>
                        <div class="dimmed_flex">
                            <div class="dimmed_box"></div>
                            <div class="dimmed_subtitle"></div>
                        </div>
                        <div class="dimmed_flex">
                            <div class="dimmed_box"></div>
                            <div class="dimmed_subtitle"></div>
                        </div>
                        <div class="dimmed_flex">
                            <div class="dimmed_box"></div>
                            <div class="dimmed_subtitle"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<ng-template #noFormsAccess>
    <core-helpers-box-http-error [code]="''"[message]="'Not Access'"></core-helpers-box-http-error>
</ng-template>
